import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { PageTaskResponse } from '@services/associations/model/pageTaskResponse';
import { TaskListRequest } from '@services/associations/model/taskListRequest';
import { TaskResponse } from '@services/associations/model/taskResponse';
import { PaginationModel } from '@shared/models/pagination.model';

export enum LeadsListActionTypes {
  LoadTasks = '[LeadsList] Load Tasks',
  LoadTasksSuccess = '[LeadsList] Load Tasks Success',
  LoadTasksFailure = '[LeadsList] Load Tasks Failure',
  EditTasksSuccess = '[LeadsList] Edit Tasks Success',
  EditMultipleTasks = '[LeadsList] Edit Multiple Tasks',
  DeleteTasks = '[LeadsList] Delete Tasks',
  DeleteTasksSuccess = '[LeadsList] Delete Tasks Success',
  DeleteTasksFailure = '[LeadsList] Delete Tasks Failure',
  SetFilter = '[LeadsList] Set Filter',
  UpdateFilter = '[LeadsList] Update Filter',
  ClearFilter = '[LeadsList] Clear Filter',
  ChangePage = '[LeadsList] Change Page',
  SetInitialPagination = '[LeadsList] Set Initial Pagination',
  SetInitialState = '[LeadsList] Set Initial State',
}

/** Load Tasks */
export class LoadTasks implements Action {
  readonly type = LeadsListActionTypes.LoadTasks;
  constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadTasksSuccess implements Action {
  readonly type = LeadsListActionTypes.LoadTasksSuccess;
  constructor(public payload: PageTaskResponse) { }
}

export class LoadTasksFailure implements Action {
  readonly type = LeadsListActionTypes.LoadTasksFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Edit Task Success (dispatch From Board Effects) */
export class EditTasksSuccess implements Action {
  readonly type = LeadsListActionTypes.EditTasksSuccess;
  constructor(public payload: TaskResponse, public isSocket?: boolean) { }
}

/** Edit Multiple Tasks */
export class EditMultipleTasks implements Action {
  readonly type = LeadsListActionTypes.EditMultipleTasks;
  constructor(public payload: TaskResponse[]) { }
}

/** Delete Tasks */
export class DeleteTasks implements Action {
  readonly type = LeadsListActionTypes.DeleteTasks;
  constructor(public payload: string) {}
}

export class DeleteTasksSuccess implements Action {
  readonly type = LeadsListActionTypes.DeleteTasksSuccess;
  constructor(public payload: string) { }
}

export class DeleteTasksFailure implements Action {
  readonly type = LeadsListActionTypes.DeleteTasksFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Set Filter */
export class SetFilter implements Action {
  readonly type = LeadsListActionTypes.SetFilter;
  constructor(public payload: TaskListRequest) {}
}

export class UpdateFilter implements Action {
  readonly type = LeadsListActionTypes.UpdateFilter;
  constructor(public payload: TaskListRequest) {}
}

/** Clear Filter */
export class ClearFilter implements Action {
  readonly type = LeadsListActionTypes.ClearFilter;
}

/** Change Page */
export class ChangePage implements Action {
  readonly type = LeadsListActionTypes.ChangePage;
  constructor(public payload: PaginationModel) { }
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
  readonly type = LeadsListActionTypes.SetInitialPagination;
}

/** Set Initial State */
export class SetInitialState implements Action {
  readonly type = LeadsListActionTypes.SetInitialState;
}

export type LeadsListActions =
  | LoadTasks
  | LoadTasksSuccess
  | LoadTasksFailure
  | EditTasksSuccess
  | EditMultipleTasks
  | DeleteTasks
  | DeleteTasksSuccess
  | DeleteTasksFailure
  | SetFilter
  | UpdateFilter
  | ClearFilter
  | ChangePage
  | SetInitialPagination
  | SetInitialState
  ;

